import React from "react";
import SharedBanner from "../../shared/Banner/Banner";
import BannerImg from "../../../assets/images/redirect/background.svg";
import LeftRight from "../../shared/LeftRight/LeftRight";
import Img1 from "../../../assets/images/redirect/ai.svg";
import { FormattedMessage } from "react-intl";

export default function Banner() {
  const data = {
    title: "HOST AI",
    link: "Go to homepage",
    to: "/",
    img: Img1,
  };
  return (
    <SharedBanner img={BannerImg} styles="home-banner">
      <LeftRight {...data} />
    </SharedBanner>
  );
}
